import PeriodValueFormulaNode from "./PeriodValueFormulaNode.js";

/**
 * `balanceFormulaNode` is a concrete implementation of `periodValueFormulaNode`
 * representing a group balance node.
 */

/**
 * TODO: write documentation
 */
export default class BalanceFormulaNode extends PeriodValueFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitBalanceNode(this, additionalInformation);
	}

	static getType() {
		return "BalanceNode";
	}

	static build(builder, additionalInformation) {
		return builder.buildPeriodValueNode(this, additionalInformation);
	}
}
